import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { MediaDocLinksRes } from "../../types/ResType";
import { useAppSelector } from "../../utils/hooks";

export const useConversationMedia = () => {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  return useQuery<MediaDocLinksRes, Error>(
    ["media", currentConversationData.chat_id],
    async () => {
      const response = await axiosInstance.post<MediaDocLinksRes>("chat/chat-media", {
        chat_id: currentConversationData.chat_id,
        message_type: "media",
        pageSize: 1000,
      });
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: currentConversationData.chat_id > 0,
    },
  );
};
